export const init = () => {
  const ob = new MutationObserver(() => {
    const sets = document.querySelectorAll('.s-card-banner-set:not([data-initialized="true"])');

    if (!sets.length) return;

    sets.forEach((set, index) => {
      const titles = set.querySelectorAll('.b-card-banner__top .title');
      const subtitles = set.querySelectorAll('.b-card-banner__top .subtitle');
      const textWrappers = set.querySelectorAll('.b-card-banner__bottom .text-wrapper');

      if (!titles.length || !subtitles.length || !textWrappers.length) return;

      const runHandlers = () => {
        syncTopHeights(titles);
        syncTopHeights(subtitles);
        syncTopHeights(textWrappers);
      };

      const runHandlersExceptLast = () => {
        const trimLast = nodeList => Array.from(nodeList).slice(0, -1);

        syncTopHeights(trimLast(titles));
        syncTopHeights(trimLast(subtitles));
        syncTopHeights(trimLast(textWrappers));
      };

      const clearHeights = () => {
        [...titles, ...subtitles, ...textWrappers].forEach(el => {
          el.style.height = '';
        });
      };

      const resizeKey = `_resizeTimer_${index}`;

      const conditionalRunHandlers = () => {
        if (window.innerWidth <= 671) {
          clearHeights();
          return;
        }

        const isTablet = window.innerWidth <= 1055;
        const cards = set.querySelectorAll('.b-card-banner');

        if (isTablet && cards.length === 3) {
          clearHeights();
          runHandlersExceptLast();
        } else {
          runHandlers();
        }
      };

      if (document.readyState === 'complete') {
        conditionalRunHandlers();
      } else {
        window.addEventListener('load', conditionalRunHandlers);
      }

      window.addEventListener('resize', () => {
        clearTimeout(window[resizeKey]);
        window[resizeKey] = setTimeout(conditionalRunHandlers, 150);
      });

      // Init
      conditionalRunHandlers();
      set.setAttribute('data-initialized', 'true');
    });
  });
  ob.observe(document.body, {
    childList: true,
    subtree: true
  });
};

function syncTopHeights(elements) {
  let maxHeight = 0;

  elements.forEach(el => {
    el.style.height = 'auto';
  });

  elements.forEach(el => {
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  elements.forEach(el => {
    el.style.height = `${maxHeight}px`;
  });
}
